import React, { useEffect, useMemo, useRef } from 'react';
import LocalOpsSheet from './LocalOpsSheet';

const formatPrice = (price = {}) =>
  price.display ||
  (price.amountCents ? `$${(price.amountCents / 100).toFixed(2)}` : '$9.99');

export default function LocalOpsFoundingHelperPassModal({
  open,
  offer,
  busy = false,
  error = '',
  onPrimary,
  onSkip,
  onDismiss,
}) {
  const primaryRef = useRef(null);
  const region = offer?.regionDisplayName || 'Local';
  const offerName = offer?.offerName || `${region} Founding Helper Pass`;
  const priceLabel = useMemo(() => formatPrice(offer?.price), [offer?.price]);

  useEffect(() => {
    if (!open) return undefined;
    const raf = requestAnimationFrame(() => {
      primaryRef.current?.focus?.();
    });
    return () => cancelAnimationFrame(raf);
  }, [open]);

  return (
    <LocalOpsSheet
      open={open}
      onClose={onDismiss}
      title={offerName}
      ariaLabel={offerName}
      className="localops-sheet--centered localops-founding-pass"
    >
      <div className="localops-founding-pass__body">
        <p>{region} helper access is open now.</p>
        <p>
          Imagine earning on your own terms. Working when it fits your life.
          Turning your time, skills, rides, errands, help, and local offerings
          into real income from people nearby.
        </p>
        <p>
          A {region} where people can earn locally, serve locally, and prosper
          locally.
        </p>
        <p>
          That is what we are building - and we are working tirelessly to
          exceed that dream.
        </p>
        <p>Founding helpers are different.</p>
        <p>
          Lock in early. Help open the {region} helper network. We won't forget
          that.
        </p>
        <p>
          Get your one-time {priceLabel} founding rate before this early rate
          closes.
        </p>
      </div>

      {error ? (
        <div className="localops-founding-pass__error" role="alert">
          {error}
        </div>
      ) : null}

      <div className="localops-founding-pass__actions">
        <button
          type="button"
          className="localops-btn localops-founding-pass__primary"
          onClick={onPrimary}
          disabled={busy}
          ref={primaryRef}
        >
          {busy ? 'Opening Stripe...' : `Lock in my Founding Pass - ${priceLabel}`}
        </button>
        <button
          type="button"
          className="localops-btn localops-btn--ghost localops-founding-pass__secondary"
          onClick={onSkip}
          disabled={busy}
        >
          Continue without pass
        </button>
      </div>

      <div className="localops-founding-pass__small-print">
        One-time founding rate. No monthly fee. No subscription.
        <br />
        Local task availability varies by demand.
      </div>
    </LocalOpsSheet>
  );
}
